import type transform from '../to/locked-times';

export default (LockedTimes: ReturnType<typeof transform>) => {
  if (LockedTimes.length != new Set(LockedTimes.map(x => x.id)).size)
    throw new Error('(Core::From::V2::LockedTimes) LockedTimes array have two or more LockedTimes with the same ID');

  return LockedTimes
    .map(x => {
      if (!x.id)
        throw new Error('(Core::From::V2::LockedTimes) Locked time id is undefined');

      return { ...x };
    });
};
